var exports = {
  "l": "placeholderContainer__6zynf9",
  "R": "placeholderText__oBzhrW",
};

module.exports = exports;
